import React, { useRef } from 'react';
import noop from 'lodash/noop';
import identity from 'lodash/identity';
import PropTypes from 'prop-types';
import { CustomSelect, DropDownTitle } from './nativeStyles';

const NativeSelect = ({
  value = '', onOptionSelect = noop, options = [], renderer, keyBy = identity, disabled = false, ...rest
}) => {
  const userInteractedRef = useRef(false);
  const previousValueRef = useRef(keyBy(value));

  // Keep previousValueRef in sync with value prop
  const currentKeyedValue = keyBy(value);
  if (previousValueRef.current !== currentKeyedValue) {
    previousValueRef.current = currentKeyedValue;
  }

  return (
    <DropDownTitle disabled={disabled}>
      <CustomSelect
        {...rest}
        disabled={disabled}
        onClick={() => {
          userInteractedRef.current = true;
        }}
        onTouchStart={() => {
          userInteractedRef.current = true;
        }}
        onChange={(event) => {
          const selectedValue = event.target.value;

          // Only fire onChange if user actually interacted AND value changed
          if (userInteractedRef.current && selectedValue !== previousValueRef.current) {
            const selectedOption = options.find((a) => keyBy(a).toString() === selectedValue);
            if (selectedOption) {
              previousValueRef.current = selectedValue;
              onOptionSelect(selectedOption);
              userInteractedRef.current = false;
            }
          }
        }}
        value={currentKeyedValue}
      >
        {options.map((singleOption) => (
          <option key={keyBy(singleOption)} value={keyBy(singleOption)}>
            {renderer({ value: singleOption })}
          </option>
        ))}
      </CustomSelect>
    </DropDownTitle>
  );
};

NativeSelect.propTypes = {
  options: PropTypes.array,
  onOptionSelect: PropTypes.func,
  value: PropTypes.string,
  renderer: PropTypes.func.isRequired,
  keyBy: PropTypes.func,
  disabled: PropTypes.bool,
};

export default NativeSelect;
